import React from "react";
import { Flex } from "rebass/styled-components";
import { Avatar } from "../../MVVM/Components/Avatar";
import { Link } from "../atoms/link";
import styled from "styled-components";
import ReactPlaceholder from "react-placeholder";
import { TextRow } from "react-placeholder/lib/placeholders";
import theme from "../../theme/themeThree";
import { Subheader } from "../text";
import { FollowButton } from "../../components/atoms/form/button/follow";
import { getAvatarBorderLevel } from "../../MVVM/Utilities/User";
import { AvatarBorder } from "../../MVVM/Utilities/User";

const userFollowPlaceholder = (
  <>
    <TextRow
      color={theme.colors.chalkAlpha20}
      style={{
        marginBottom: theme.space[2],
        height: theme.text.title3.fontSize,
        width: "100%",
        maxWidth: "430px",
        marginTop: 0,
      }}
    />
    <TextRow
      color={theme.colors.chalkAlpha20}
      style={{
        height: theme.text.body.fontSize,
        width: "80%",
        maxWidth: "300px",
        marginTop: 0,
      }}
    />
  </>
);

export function FollowRow({
  loading,
  avatar,

  allstarUser,
  user,
  ...props
}) {
  const avatarBorderLevel = getAvatarBorderLevel(user);

  return (
    <Flex
      {...props}
      justifyContent={"space-between"}
      alignItems="center"
      width={"100%"}
    >
      {avatarBorderLevel ? (
        <AvatarBorder type={avatarBorderLevel} size="nav">
          <Avatar
            size={["nav"]}
            image={avatar}
            to={`/profile?user=${props.ownerId}`}
          />
        </AvatarBorder>
      ) : (
        <Avatar
          size="nav"
          image={avatar}
          to={`/profile?user=${props.ownerId}`}
        />
      )}

      <OwnerAndFollowers ml={4}>
        <ReactPlaceholder
          customPlaceholder={userFollowPlaceholder}
          ready={!loading}
        >
          <StyledLink
            mb={2}
            fontSize={[2, 2, 2, 2, 3]}
            color="ice"
            variant="link.clipPageOwner"
            to={`/profile?user=${props.ownerId}`}
          >
            {props.username ? props.username : "Allstar User"}
          </StyledLink>
          <Flex alignItems="flex-end">
            <StyledSubheader mr={3} pr={3} fontSize={1} color="chalk">
              {props.userRank ? props.userRank : null}
            </StyledSubheader>
          </Flex>
        </ReactPlaceholder>
      </OwnerAndFollowers>

      {allstarUser?.user?._id !== props.ownerId && (
        <FollowButton
          ml={1}
          flex={true}
          size="tiny"
          alignSelf="center"
          userId={props.ownerId}
          displayName={props.username}
          avatar={avatar}
          openModal={props.openModal}
          followerData={props.followerData}
          isModal={props.isModal}
          followUnfollow={props.followUnfollow}
          allstarUser={allstarUser}
          style={{ minWidth: "40px" }}
        />
      )}
    </Flex>
  );
}

const StyledLink = styled(Link)`
  line-height: 1em;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledSubheader = styled(Subheader)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const OwnerAndFollowers = styled(Flex)`
  flex-grow: 1;
  flex-direction: column;
  justify-content: center;
  text-overflow: ellipsis;
`;
